// This season's show: the performances from Storyblok (global/events) and the title from utils/show.ts
export const useShow = async () => {
  const data = await useHrStoryblok('cdn/stories', { starts_with: 'global/events/', content_type: 'Event', per_page: 100 })
  const stories: Array<any> = (data as any)?.stories ?? []
  return { title: SHOW_TITLE, stories, ...usePerformances(stories) }
}
